import { useState, type ReactNode } from 'react'

/** A list bounded at `shown` with a Show all link, so a client of hundreds of facilities never paints them all unasked. */
export function ShowMore<T>({ items, shown, noun, render }: { items: readonly T[]; shown: number; noun: string; render: (items: readonly T[]) => ReactNode }) {
  const [all, setAll] = useState(false)
  const visible = all ? items : items.slice(0, shown)
  return (
    <>
      {render(visible)}
      {items.length > shown && (
        <button type="button" onClick={() => setAll((current) => !current)} className="self-start text-[11px] font-bold text-marine hover:text-marine-dk">
          {all ? `Show the first ${shown}` : `Show all ${items.length} ${noun}`}
        </button>
      )}
    </>
  )
}
